import React, { ReactNode } from "react";
import { usePermissions } from "../../hooks/usePermissions";
import { canUseImportExportPermission } from "../../utils/importExportPermissions";

export interface PermissionGateProps {
  permission?: string;
  permissions?: string[];
  children?: ReactNode;
  fallback?: ReactNode;
}

/**
 * Renders children only if the user has the required permission(s).
 */
const PermissionGate = ({
  permission,
  permissions: requiredPermissions,
  children,
  fallback = null,
}: PermissionGateProps) => {
  const { hasVisiblePermission, permissions: userPermissions, enabledModules, isLoading } = usePermissions();

  const canAccess = (slug: string) =>
    hasVisiblePermission(slug) || canUseImportExportPermission(enabledModules, userPermissions, slug);

  if (isLoading) {
    return <>{fallback}</>;
  }

  let hasAccess = false;
  if (permission) {
    hasAccess = canAccess(permission);
  } else if (Array.isArray(requiredPermissions) && requiredPermissions.length > 0) {
    hasAccess = requiredPermissions.some((p) => canAccess(p));
  } else {
    hasAccess = true;
  }

  return hasAccess ? <>{children}</> : <>{fallback}</>;
};

export default PermissionGate;
